module.exports = __webpack_public_path__ + "img/photoapp.13bf4c41.png";